// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { P, StyledFormItem } from 'common/styles/oc-styled-components';
import { Radio } from 'opencare-crown';
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';

import { PrimaryMemberSwitch } from '../../../checkout-styled-components';

// Other

// Component
const InsuranceSwitchRowForm = ({ defaultValue, handleValueChange }) => {
  const { layout } = useWindowDimensions();

  return (
    <StyledFormItem
      marginbottom={`${layout === DIMENSIONS.MOBILE ? '10px' : '22px'}`}
      name="hasInsurance"
      initialValue={defaultValue}
    >
      <P margin="5px 0 10px">Do you have insurance?</P>
      <Radio.Group
        buttonStyle="solid"
        style={{ marginTop: 5, display: 'flex' }}
        value={defaultValue}
      >
        <PrimaryMemberSwitch
          value
          border="10px 0 0 10px"
          onClick={() => handleValueChange(true)}
        >
          <P fontSize="16px" fontWeight="600" margin="0">
            Yes, I have
          </P>
        </PrimaryMemberSwitch>
        <PrimaryMemberSwitch
          value={false}
          border="0 10px 10px 0"
          onClick={() => handleValueChange(false)}
        >
          <P fontSize="16px" fontWeight="600" margin="0">
            No, I do not
          </P>
        </PrimaryMemberSwitch>
      </Radio.Group>
    </StyledFormItem>
  );
};

InsuranceSwitchRowForm.propTypes = {
  defaultValue: PropTypes.bool,
  handleValueChange: PropTypes.func,
};

export default InsuranceSwitchRowForm;
